import React from "react";
import "./Footer.css";
export default function Footer() {
  return (
    <>
      <div className="footer-container">
        <p>Created by Eric Dao 2022</p>
      </div>
    </>
  );
}
